var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.1893 21.5679L0.439322 11.9798C-0.146441 11.4037 -0.146441 10.4697 0.439322 9.89365L2.56059 7.80753C3.14636 7.23144 4.09616 7.23144 4.68192 7.80753L11.25 14.2665L25.3181 0.432029C25.9038 -0.14401 26.8536 -0.14401 27.4394 0.432029L29.5607 2.51814C30.1464 3.09418 30.1464 4.02816 29.5607 4.60426L12.3107 21.568C11.7248 22.144 10.7751 22.144 10.1893 21.5679V21.5679Z","fill":"white"}));
}

Tick.defaultProps = {"width":"30","height":"22","viewBox":"0 0 30 22","fill":"none"};

module.exports = Tick;

Tick.default = Tick;
